export const dataLayerPush = (event) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push(event);
};

export const trackAddToCart = (trackingProduct, quantity) => {
    if (
        trackingProduct &&
        trackingProduct.items &&
        trackingProduct.items.length > 0
    ) {
        trackingProduct.items[0].quantity = parseInt(quantity);
    }

    dataLayerPush({
        event: 'add_to_cart',
        ecommerce: trackingProduct,
    });
};

export const trackViewItem = (trackingProduct) => {
    if (
        trackingProduct &&
        trackingProduct.items &&
        trackingProduct.items.length > 0
    ) {
        trackingProduct.items[0].quantity = 1;
    }

    dataLayerPush({
        event: 'view_item',
        ecommerce: trackingProduct,
    });
};

export const trackCheckout = (trackingProducts) => {
    dataLayerPush({
        event: 'begin_checkout',
        ecommerce: trackingProducts,
    });
};

export const trackPurchase = (trackingPurchase) => {
    dataLayerPush({
        event: 'purchase',
        ecommerce: trackingPurchase,
    });
};
